import { DefaultLayout } from "src/components/Layout"
import Head from "next/head"
import { NextPage } from "next"
import { useState, useEffect } from "react"
import Link from "next/link"
import { Smoother } from "src/features/auth"
import { camelCase, SnakeCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { GetTokenFromCookies } from "src/lib/utils/cookies"

const getSmoothers = async (token: string) => {
  const response = await fetch(SMOOTH_SMOOTHER_API_URL + "/smoothers", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  const json = await response.json()
  const smoothers = json["data"].map((d: SnakeCase<Smoother>) => camelCase(d))
  return smoothers as Smoother[]
}

const SmoothersPage: NextPage = () => {
  const [smoothers, setSmoothers] = useState<Smoother[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  // smoothersデータを取得
  useEffect(() => {
    const fetchSmoothers = async () => {
      try {
        setIsLoading(true)
        const token = GetTokenFromCookies()
        const smoothersData = await getSmoothers(token)
        setSmoothers(smoothersData)
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Smoothersの取得に失敗しました"))
      } finally {
        setIsLoading(false)
      }
    }

    fetchSmoothers()
  }, [])

  if (isLoading) {
    return (
      <DefaultLayout>
        <Head>
          <title>Smoothers一覧 | for CS</title>
        </Head>
        <div>loading...</div>
      </DefaultLayout>
    )
  }

  if (error) {
    return (
      <DefaultLayout>
        <Head>
          <title>Smoothers一覧 | for CS</title>
        </Head>
        <div>エラーが発生しました: {error.message}</div>
      </DefaultLayout>
    )
  }

  return (
    <DefaultLayout>
      <Head>
        <title>Smoothers一覧 | for CS</title>
      </Head>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "calc(100vh - 70px)",
          padding: "30px 0",
        }}
      >
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Smoothers
        </h1>
        <ul
          style={{
            width: 700,
          }}
        >
          {smoothers.map((smoother) => (
            <li
              key={smoother.id}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                marginBottom: "1rem",
                fontSize: "1.2rem",
              }}
            >
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img
                src={smoother.iconSrc}
                alt={smoother.name}
                style={{
                  display: "block",
                  width: "30px",
                  height: "30px",
                  marginRight: "1rem",
                  border: "1px solid #ccc",
                }}
              />
              <Link
                href={`/admin/smoothers/${smoother.id}/edit`}
                style={{
                  marginRight: "1rem",
                  textDecoration: "underline",
                }}
              >
                {smoother.id}. {smoother.name}
              </Link>
              <span
                style={{
                  marginRight: "1rem",
                }}
              >
                {smoother.email}
              </span>
              <span
                style={{
                  marginRight: "1rem",
                }}
              >
                {smoother.roleType}
              </span>
              <span style={{}}>{smoother.uid}</span>
            </li>
          ))}
        </ul>
        <Link
          href="/admin/smoothers/new"
          style={{
            textDecoration: "underline",
            fontSize: "1.2rem",
          }}
        >
          new
        </Link>
      </div>
    </DefaultLayout>
  )
}

export default SmoothersPage
